<template>
	<div>
		<b-modal v-model="isVisible" centered hide-header-close @show="load">
			<base-select :options="patients" v-model="patientId" valueProp="id" :placeholder="$t('menu.change-user-placeholder')"
						label="fullName" :loading="loading"></base-select>
			<template v-slot:modal-footer>
				<base-button variant="primary" @click="changeUser(patientId)" :disabled="!value">{{ $t('menu.change-user') }}</base-button>
			</template>
		</b-modal>
		<b-modal else centered hide-header-close>
			<b-alert variant="info">
				{{ $t('menu.change-user-no-patients') }}
			</b-alert>
			<template v-slot:modal-footer>
				<base-button variant="primary" @click="createAssociatedPatient" :disabled="!value">{{ $t('menu.change-user-create') }}</base-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import PatientsRepository from '@/repositories/PatientsRepository'
import { BModal } from 'bootstrap-vue'
import accountMixin from '@/mixins/account.mixin'

export default {
	name: 'ChangeUserModal',
	mixins: [accountMixin],
	components: {
		PatientsRepository,
		BModal
	},
	props: {
		value: [Boolean]
	},
	data () {
		return {
			loading: true,
			patients: [],
			patientId: null
		}
	},
	methods: {
		createAssociatedPatient () {
			this.$helpers.goToPatientWebapp('profile', this.$apiToken)
		},
		load () {
			PatientsRepository.getAssociatedPatients().then((response) => {
				if (response.data && response.data.length > 0) {
					this.patients = response.data
				}
				this.loading = false
			})
		}
	},
	computed: {
		isVisible: {
		get () {
			return this.value
		},
		set (val) {
			this.$emit('input', val)
		}
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/ChangeUserModal.vue